/**
 * WordPress dependencies
 */
import type { WordPressComponentProps } from '@wordpress/components/build-types/context';

/**
 * Internal dependencies
 */
import {
	Root,
	Viewbox,
	TopStroke,
	RightStroke,
	BottomStroke,
	LeftStroke,
} from './styles/overflow-control-icon-styles';
import type { OverflowControlIconProps, OverflowControlProps } from './types';

const BASE_ICON_SIZE = 24;

export default function OverflowControlIcon( {
	size = 24,
	side = 'all',
	sides,
	...props
}: WordPressComponentProps< OverflowControlIconProps, 'span' > ): JSX.Element {
	const isSideDisabled = (
		value: NonNullable< OverflowControlProps[ 'sides' ] >[ number ]
	) => sides?.length && ! sides.includes( value );

	const hasSide = (
		value: NonNullable< OverflowControlProps[ 'sides' ] >[ number ]
	) => {
		if ( isSideDisabled( value ) ) {
			return false;
		}

		return side === 'all' || side === value;
	};

	const top = hasSide( 'vertical' );
	const right = hasSide( 'horizontal' );
	const bottom = hasSide( 'vertical' );
	const left = hasSide( 'horizontal' );

	// Simulates SVG Icon scaling.
	const scale = size / BASE_ICON_SIZE;

	return (
		<Root style={ { transform: `scale(${ scale })` } } { ...props }>
			<Viewbox>
				<TopStroke isFocused={ top } />
				<RightStroke isFocused={ right } />
				<BottomStroke isFocused={ bottom } />
				<LeftStroke isFocused={ left } />
			</Viewbox>
		</Root>
	);
}
